import styled from '@emotion/styled';

import Button from '$shared/components/button';

export const StyledResetButton = styled(Button)(({ theme }) => ({
    margin: `${theme.space[5]} 0px `,
    fontSize: theme.fontSizes.md,
    fontFamily: theme.fonts.headline,
}));
